export const damageConstants = {
    CREATE_REQUEST: 'DAMAGE_CREATE_REQUEST',
    CREATE_SUCCESS: 'DAMAGE_CREATE_SUCCESS',
    CREATE_FAILURE: 'DAMAGE_CREATE_FAILURE',

    UPDATE_REQUEST: 'DAMAGE_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'DAMAGE_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'DAMAGE_UPDATE_FAILURE',

    GETALL_REQUEST: 'DAMAGE_GETALL_REQUEST',
    GETALL_SUCCESS: 'DAMAGE_GETALL_SUCCESS',
    GETALL_FAILURE: 'DAMAGE_GETALL_FAILURE',

    DELETE_REQUEST: 'DAMAGE_DELETE_REQUEST',
    DELETE_SUCCESS: 'DAMAGE_DELETE_SUCCESS',
    DELETE_FAILURE: 'DAMAGE_DELETE_FAILURE',
    
    DIALOG_REQUEST:'DIALOG_REQUEST',

    LOADING_REQUEST:'LOADING_REQUEST'
};